// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { arrayOf, object, func, bool } from 'prop-types';
import styled from '@emotion/styled';
import { Button } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import FilterListComponent from 'Components/Filters/FilterListComponent';

const StyledButton = styled(Button)`
  outline: 0 none !important;
  border: 0 none !important;
  background-color: transparent !important;
  min-height: 0;
  height: 15px;
  font-size: 0.875rem;
  margin: 5px 0;
  &.active, &:active {
    font-weight: 600;
  }

  &:not(:hover) {
    text-decoration: none;
  }
`;

const CategoriesComponent = memo(({ categories = [], selected = {}, onToggle, open, onClick }) => {
  const { t } = useTranslation();
  const renderCategory = category => {
    const handleOnClick = () => onClick(category);

    return (
      <StyledButton
        key={ category.id }
        kind="ghost"
        className={ (category.id === selected?.id) ? 'filterItem active' : 'filterItem' }
        onClick={ handleOnClick }
      >
        { category.name }
        { ('count' in category) && (<span className="count">({ category.count })</span>) }
      </StyledButton>
    );
  };

  return (
    <FilterListComponent
      filterTitle={ t('filters.categories.title') }
      showSearch={ categories.length > 10 }
      onToggle={ onToggle }
      cx={ open ? 'open' : 'closed' }
    >
      <div className="options">
        { (categories || []).map(renderCategory) }
      </div>
    </FilterListComponent>
  );
});

CategoriesComponent.propTypes = {
  categories: arrayOf(object),
  onClick: func,
  selected: object,
  open: bool,
  onToggle: func,
};
CategoriesComponent.displayName = 'CategoriesComponent';

export default CategoriesComponent;
